import React, { CSSProperties, useCallback } from 'react';
import { Image, Eye16 as IconShow16, Comments16 as IconComment16 } from '@cian/ui-kit';
import { Link } from 'react-router-dom';

import { Chip } from '../Chip';
import { IArticlesMainAttributesSchema } from '../../repositories/journal/entities/journal/ArticlesMainAttributesSchema';
import { IArticlesMainAttributesRubricSchema } from '../../repositories/journal/entities/journal/ArticlesMainAttributesRubricSchema';
import { numberWithDelimiter } from '../../utils';
import * as s from './MainArticleDetailed.css';

export interface IMainArticleDetailed extends Pick<IArticlesMainAttributesSchema, 'title' | 'image' | 'commentsCount'> {
  titleColor?: CSSProperties['color'];
  rubric?: IArticlesMainAttributesRubricSchema;
  viewsCount: IArticlesMainAttributesSchema['numViews'];
  articleUrl: string;
  onRubricButtonClick?(e: React.MouseEvent): void;
  onClick(e: React.MouseEvent): void;
}

/** Топовая статья на Главной (полный вид) */
export const MainArticleDetailed = ({
  image,
  title,
  titleColor,
  rubric,
  viewsCount,
  commentsCount,
  articleUrl,
  onClick,
  onRubricButtonClick,
}: IMainArticleDetailed) => {
  const handleArticleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
      onClick(e);
    },
    [onClick],
  );

  const handleRubricClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();

      if (onRubricButtonClick) {
        onRubricButtonClick(e);
      }
    },
    [onRubricButtonClick],
  );

  return (
    <div className={s['wrapper']} data-web-ui-test-id="MainArticleDetailed" onClick={handleArticleClick}>
      <div className={s['content-wrapper']}>
        <div className={s['activity-panel']}>
          {rubric && (
            <Chip size={'XS'} theme="stroke_secondary" onClick={handleRubricClick} url={rubric.url}>
              {rubric.name}
            </Chip>
          )}

          <div className={s['views']}>
            <IconShow16 />
            {numberWithDelimiter(viewsCount)}
          </div>

          <div className={s['comments']}>
            <IconComment16 />
            {numberWithDelimiter(commentsCount)}
          </div>
        </div>

        <Link to={articleUrl} className={s['title']} style={{ color: titleColor }} onClick={handleArticleClick}>
          {title}
        </Link>
      </div>

      <Image alt={title} objectFit="cover" preloader src={image || ''} theme="light" title={title} />
    </div>
  );
};
